"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Box_1 = __importDefault(require("@mui/material/Box"));
var styles_1 = require("@mui/material/styles");
var general_1 = require("utils/general");
var ModalContent = (0, styles_1.styled)(Box_1.default, {
    shouldForwardProp: (0, general_1.omitProps)('condense', 'disablePadding'),
})(function (_a) {
    var theme = _a.theme, condense = _a.condense, disablePadding = _a.disablePadding;
    return ({
        borderBottom: '1px solid rgba(112, 119, 124, 0.35)',
        borderTop: '1px solid rgba(112, 119, 124, 0.35)',
        padding: disablePadding ? 0 : theme.spacing(condense ? 2 : 4, 4),
        overflow: 'auto',
    });
});
exports.default = ModalContent;
